import { ref, BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { number_format, num_word, initYaCaptcha, YA_CAPTCHA_ENABLED } from '../../tools/functions';
import { VplRouter } from '../../services/vpl-router/vpl-router';
import { leadGoal } from '../../services/analytics/analytics';
import { NewsletterCheckbox } from '../newsletter/newsletter-checkbox';


export const FastView = {
    components: { NewsletterCheckbox },
    computed: {
        ...mapState(vplSiteStore, ['basket','fastview', 'SITE_TEMPLATE_PATH', 'YA_CLIENT_KEY', 'templateData']),
        currentLocation(){
          return window.location.href;
        }
    },
    data(){
        return {
          captcha: false,
          yatoken: ''
        }
    },
    updated(){
      $(this.$el).find('.js-input-touchspin').val(1);
    },
    mounted(){
      initYaCaptcha();
      let interval = setInterval(()=>{
        if(this.captcha === false &&  (!YA_CAPTCHA_ENABLED || typeof window.smartCaptcha !== "undefined") && this.YA_CLIENT_KEY){

          let self = this;
          this.captcha = YA_CAPTCHA_ENABLED && window.smartCaptcha.render($(this.$el).find('.js-captcha')[0], {
              sitekey: self.YA_CLIENT_KEY,
              invisible: true,
              callback: function(token) {
                  window.yaToken = token;
                  self.yatoken = token;
                  self.sendForm();
              },
              hideShield: true,
          });

          new Cleave($(this.$el).find('.js-phone')[0], {
            numericOnly: true,
            delimiters: [" (", ") ", "-", "-"],
            blocks: [1, 3, 3, 2, 2],
            delimiterLazyShow: true
          });

          clearInterval(interval);
        }
      }, 500);
      $(this.$el).find(".js-input-touchspin").each(function(){
        $(this).val(1).show().TouchSpin({min: 1});
      });
    },
    methods: {
      number_format: number_format,
      num_word: num_word,
      execCaptcha(){
          vplSiteStore.capresolved = true;
          this.sendForm();
      },
      sendForm(){
            let form = $(this.$el).find('form'),
                data = {};

            $.each($("input,textarea,button,select", form), function () {
                if ($(this).attr("type") == "checkbox") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = true;
                    }
                } else if ($(this).attr("type") == "radio") {
                    if ($(this).prop("checked")) {
                        data[$(this).attr("name")] = $(this).val();
                    }
                } else if (
                    $(this).attr("name") !== undefined &&
                    $(this).attr("name").length
                ) {
                    data[$(this).attr("name")] = $(this).val();
                }
            });

            data['WEB_FORM_ID'] = 5;
            data['web_form_submit'] = 'y';
            data['sessid'] = BX.bitrix_sessid();
            data['url'] = window.location.href; //урл для согласия
            data['form_text_36'] = window.location.href;

            data['smart-token'] = this.yatoken;

            if(vplSiteStore.capresolved){
                data['skip-captcha'] = 'Y';
            }

            $.ajax({
                url: '/ajax/form.php',
                method: 'POST',
                data: data,
                success: (response) => {
                    form.find(".is-error").removeClass("is-error");
                    response = JSON.parse(response);

                    if (!response.ERRORS || !Object.keys(response.ERRORS).includes("CAPTCHA")) {
                        vplSiteStore.capresolved = true;
                    }

                    if (response.STATUS == "OK") {
                        // тема заявки — заголовок модалки («Запросить расчет» / «Подобрать аналог»), как и для 1С
                        leadGoal('product_request', response, {
                            // корень компонента — фрагмент из двух модалок ($el — текстовый узел), поэтому по id, как в script.js
                            form_theme: $('#fastbuy .modal-title').first().text().replace(/\s+/g, ' ').trim(),
                            product_id: String((this.fastview && this.fastview.ID) || ''),
                        });
                        form.find("input[type=text],input[type=email],textarea").val("");

                        if (form.closest(".modal").length) {
                            form.closest(".modal").modal("hide");
                        }

                        $('#success-oneclick-order').modal();

                    } else {
                        for (var i in response.ERRORS) {
                            if (i == "CAPTCHA") {
                                form.find(".captcha").addClass("is-error");
                            } else {
                                form
                                    .find("[name=" + i + "]")
                                    .parent()
                                    .addClass("is-error");
                            }
                        }
                    }
                }
            });
      }
    },
    template: `
      <div class="modal-body">
        <form @submit.prevent="execCaptcha()" action="">
          <input type="hidden" name="form_text_34" :value="this.fastview.NAME">
          <div class="modal-prod">
            <div class="modal-prod__top">
              <div class="modal-prod__img" :class="{ 'no-photo' : this.fastview.PREVIEW_IMAGE === false }">
                <img :src="this.fastview.PREVIEW_IMAGE !== false ? this.fastview.PREVIEW_IMAGE : this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" alt="" title="" loading="lazy">
              </div>
              <div class="modal-prod__desc">
                <div class="modal-prod__title" v-html="this.fastview.NAME">
                </div>
                <div v-if="this.fastview.ARTNUMBER" class="modal-prod__chars">
                  Артикул: {{ this.fastview.ARTNUMBER }}
                </div>
              </div>
            </div>
            <div class="modal-prod__bottom">
              <div class="modal-prod__bottom-leftside">
                <div v-if="this.fastview.PRICE && this.fastview.PRICE.PRICE" class="product-card__price">
                    {{ number_format(this.fastview.PRICE.PRICE, 0, '.', ' ') }} ₽
                    <div class="product-card__price-old" v-if="this.fastview.PRICE.PRICE != this.fastview.PRICE.BASE_PRICE">
                      <span>{{ number_format(parseInt(this.fastview.PRICE.BASE_PRICE), 0, '.', ' ') }} ₽ </span>
                      <div v-if="this.fastview.PRICE.PERCENT" class="product-card__price-discount">{{this.fastview.PRICE.PERCENT}}%</div>
                    </div>
                </div>
                <div class="product-detail__actions-tags">
                  <div v-if="this.fastview.QUANTITY > 0 && this.fastview.STORE_COUNT > 0" class="product-card__amount-item amount">В наличии на {{this.fastview.STORE_COUNT}} {{ this.num_word(this.fastview.STORE_COUNT, ['складе', 'складах', 'складах']) }}</div>
                  <div v-else-if="this.fastview.QUANTITY <= 0 && this.fastview.TO_ORDER == 'Y' && this.fastview.DELIVERY_TIME" class="product-card__amount-item delivery">Поставка от {{this.fastview.DELIVERY_TIME}}</div>

                </div>
              </div>
              <input type="text" aria-label="" name="form_text_35" class="input-touchspin js-input-touchspin" value="1">
            </div>
          </div>
            <div class="field js-material-input is-required" :class="{active: this.templateData.userName}">
              <input class="field__input" name="form_text_30" id="order-name" autocomplete="off" type="text" :value="this.templateData.userName">
              <label class="field__label" for="order-name">Имя</label>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required" :class="{active: this.templateData.userEmail}">
              <input class="field__input" name="form_email_31" id="order-mail" autocomplete="off" type="text" :value="this.templateData.userEmail">
              <label class="field__label" for="order-mail">Электронная почта</label>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input is-required" :class="{active: this.templateData.userPhone}">
              <input class="field__input js-phone" name="form_text_32" id="order-tel" autocomplete="off" type="text" :value="this.templateData.userPhone">
              <label class="field__label" for="order-tel">Телефон</label>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="field js-material-input">
              <textarea class="field__input field__input--textarea" rows="3" name="form_textarea_33" id="modal-text" placeholder="Комментарий к заказу" autocomplete="off"></textarea>
              <span class="field__error-text">Заполнено некорректно.</span>
            </div>
            <div class="form__submit">
              <div class="form__submit-container">
                <div class="captcha">
                  <div class="captcha js-captcha">
                  </div>
                </div>
                    <button type="submit" name="web_form_submit" value="Y" class="btn btn--green">
                       Отправить
                    </button>
              </div>
              <div class="checkbox">
                <input type="checkbox" name="politic" checked class="checkbox__input js-politic js-politic-auto" id="politic-order">
                <label for="politic-order" class="checkbox__label">
                  При нажатии на кнопку «Отправить» вы соглашаетесь с <a href="/politika-konfidentsialnosti/" target="_blank">условиями о сборе персональных данных</a>
                </label>
              </div>
              <NewsletterCheckbox />
          </div>
        </form>
      </div>
    `
}